import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";


import TransferSpares from './spares';
import TransferVehicles from './vehicles';
import TransferNumberPlates from './NumberPlates'


const Reports = (props) => {

    const { type } = props
    const [transferSpares, setTransferSpares] = useState(false);
    const [transferVehicles, setTransferVehicles] = useState(false);
    const [transferNumberPlates, setTransferNumberPlates] = useState(false);
    

    useEffect(() => {
      if (type === "spares") {
        setTransferSpares(true);
        setTransferVehicles(false);
        setTransferNumberPlates(false);
      }
      else if(type== "vehicles"){
        setTransferVehicles(true);
        setTransferSpares(false);
        setTransferNumberPlates(false);
      }else{
        setTransferVehicles(false);
        setTransferSpares(false);
        setTransferNumberPlates(true);
      }
    }, type)

    return (
       <div>
          {transferSpares && <TransferSpares />}
          {transferVehicles && <TransferVehicles />}
          {transferNumberPlates && <TransferNumberPlates />}
       </div> 
    )
}

export default withRouter(Reports);